import { useState } from "react";
import { CloseTab } from "../../Icons/CloseTab";
import { OpenTab } from "../../Icons/OpenTab";

const Dropdown = (item: { type: string; description: any }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="tab-data-content">
      <div onClick={() => setIsActive(!isActive)}>
        <div className="tab-data-title">
          <h3>• {item.type}</h3>
          <div
            style={{
              display: item.description ? "flex" : "none",
            }}
          >
            {isActive ? <CloseTab /> : <OpenTab />}
          </div>
        </div>
      </div>
      {isActive && (
        <div
          className="tab-data-title"
          id="tab-description"
          style={{
            display: item.description ? "flex" : "none",
          }}
        >
          <p>{item.description}</p>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
